import { create } from "zustand";
import { CompaniesDto } from "@/shared";

interface CompanyListState {
  companyList: CompaniesDto[];
  rootCompanyList: CompaniesDto[];
  setCompanyList: (companyList: CompaniesDto[] | []) => void;
  setRootCompanyList: (rootCompanyList: CompaniesDto[] | []) => void;
}

export const useCompanyListStore = create<CompanyListState>()(set => ({
  companyList: [],
  rootCompanyList: [],
  setCompanyList: companyList => set({ companyList: companyList }),
  setRootCompanyList: rootCompanyList =>
    set({ rootCompanyList: rootCompanyList })
}));
